module.exports = __webpack_public_path__ + "static/media/12.a7b99e1c.jpg";